module.exports = __webpack_public_path__ + "img/receiving.25aa3338.png";